import { injectable, inject } from 'inversify';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import { DataroomLogoProcessingAdapter } from '@dealroadshow/file-uploader';
import { SocketClient, type ISocketClientFactory } from '@dataroom/socket-client';
import type { DataroomTenant } from '@dataroom/tenant/DataroomTenant';

@injectable()
export class LogoSocketProcessingAdapterFactory {
  constructor(
    @inject(SocketClient) private readonly socketClientFactory: ISocketClientFactory,
  ) {}

  create(tenantCode?: DataroomTenant): DataroomLogoProcessingAdapter {
    validateDataroomTenant(tenantCode!);

    const socketClient = this.socketClientFactory(tenantCode);
    return new DataroomLogoProcessingAdapter(socketClient);
  }
}
